import {
    DELETE_NON_INSITUION_VERIFIED,
    DELETE_NON_VERIFIED,
    GET_ID_INSITUTE_CLEAR_VERFIDATION_URL, GET_ORGANISATION_LIST, IMPORT_ADMIN_EXCEL, IMPORT_ADMIN_INDIVIDUAL_EXCEL, DOWNLOAD_EXCEL
} from "../../../config/adminUrlConfig";
import { ApiService, FileUploadService } from "../../../config/apiServices";

export const UploadAdminExcel = (data,insitutionType) => {
    if(insitutionType === 'Individual'){
     return FileUploadService.post(IMPORT_ADMIN_INDIVIDUAL_EXCEL,data);
    }else{
      return FileUploadService.post(IMPORT_ADMIN_EXCEL,data);
    }
    
};


// export const getOrganisationList = (currentPage, perPage) => {
//     return ApiService.get(GET_ORGANISATION_LIST);
// };


export const getOrganisationListForExcel = (userId, searchData,selectedDistrictId,selectedSubCategoryId,selectedSportId) => {
    console.log("use id", userId);
    return ApiService.get(`${DOWNLOAD_EXCEL}${userId}?search=${searchData}&city=${selectedDistrictId}&sub_category_type=${selectedSubCategoryId}&sport_id=${selectedSportId}`);
}

export const getOrganisationList = (perPage,currentPage,selectedStatus,searchData,selectedDistrictId,selectedCategory,selectedSubCategoryId,selectedSportId) => {
    return ApiService.get(`${GET_ORGANISATION_LIST}?number=${perPage}&page=${currentPage}&status=${selectedStatus}&search=${searchData}&city=${selectedDistrictId}&category_type=${selectedCategory}&sub_category_type=${selectedSubCategoryId}&sport_id=${selectedSportId}`);
};
export const getDwnLoadOrganisationList = () => {
    return ApiService.get(GET_ORGANISATION_LIST);
};



export const clearInsituteVerfication = (data) => {
    return ApiService.post(GET_ID_INSITUTE_CLEAR_VERFIDATION_URL,data);
};

// Insitution verified Delete API
export const  deleteInsitutionNonVerifiedUserData  = (data) => {
    return ApiService.post(DELETE_NON_INSITUION_VERIFIED,data);
}

